module.exports = __webpack_public_path__ + "media/jumbo_video.b9520cb2.mp4";